import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_kids_baby: FaireCategoryEntity = {
  token: "cat_kids-baby",
  type: "category",
  name: "Kids & baby",
  level: 1,
  href: "/category/kids-baby",
  childCategoryTokens: [
    "cat_kids-all",
    "cat_kids-new-products",
    "cat_kids-new-brands",
    "cat_kids-bestsellers",
    "cat_kids-toys",
    "cat_kids-baby-gear",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
